import 'css-chunk:src/applications/ProductFulfillmentApp/NoCatalogueProductSelection/components/ProjectConfigSetupDrawer/ProjectConfigSetupDrawer.styles.scss';export default {
  "Wizard": "_Wizard_13djc_1",
  "content": "_content_13djc_1",
  "header": "_header_13djc_6",
  "headerContentWrapper": "_headerContentWrapper_13djc_18",
  "headerIcon": "_headerIcon_13djc_23",
  "mainContentWrapper": "_mainContentWrapper_13djc_26",
  "footer": "_footer_13djc_32",
  "footerButton": "_footerButton_13djc_42"
};